/* eslint-disable no-unused-vars */
export default {
  getOnboardingProperty:
    state => ({ deviceType, property }) => {
      const onboardingType = `onboarding${
        deviceType.charAt(0).toUpperCase() + deviceType.slice(1)
      }`;

      return state[onboardingType][property];
    },
};
